import { apiService } from "@blacknut/javascript-sdk/dist";
import { State } from "core/redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import nativeBridge from "./NativeBridge";
import { logD, logE, logI } from "@blacknut/logging/dist";
import { amazonUpdateInfo } from "@blacknut/javascript-sdk/dist/api/User/Action/amazonUpdateInfo";
import { LOGGING_TAG } from "./Utils";

const useUserChange = () => {
  const { profile } = useSelector((state: State) => state.profilesState);
  useEffect(() => {
    if (
      profile?.isMaster &&
      apiService.userAgent.brand?.toLocaleLowerCase() === "amazon" &&
      nativeBridge.module?.getAmazonBillingInfo
    ) {
      nativeBridge.module
        ?.getAmazonBillingInfo()
        .then((res) => {
          logI(LOGGING_TAG, "Got amazon info: %o", res);
          amazonUpdateInfo(res).subscribe({
            next: () => {
              logD(LOGGING_TAG, "Amazon user info successfully posted");
            },
            error: (error) => {
              logE(LOGGING_TAG, "Caught error posting amazon user info", error);
            },
          });
        })
        .catch((e) => {
          logE(LOGGING_TAG, "Caught error getting amazon user info: %o", e);
        });
    }
  }, [profile]);
};

export default useUserChange;
export { useUserChange };
